/**
 * Created by JIocb on 26.05.2017.
 */

namespace Factive.Game
{
    export class UserScoreModel {

        private _totalScore:number;
        private _scoreByCombination:Array<Array<number>> = [];

        private _bag:Array<DiceData> = [];

        public constructor()
        {

        }

        public removeScore(combinationType:number,score:number,multiplier:number = 1):void
        {
            this._scoreByCombination[combinationType][multiplier] = 0;
            this._totalScore -=score*multiplier;
        }

        public addScore(combinationType:number,score:number,multiplier:number = 1):void
        {

            this._scoreByCombination[combinationType] = this._scoreByCombination[combinationType] || [];
            this._scoreByCombination[combinationType][multiplier] = score*multiplier;

            var l:number = this._scoreByCombination.length;

            this._totalScore = 0;
            for(var i:number = 0; i < l; i++)
            {
                for(var j:number = 0; j<3;j++) {
                    var temp:number = this._scoreByCombination[i][j];
                    if (temp > 0) {
                        this._totalScore += temp;
                    }
                }
            }
        }

        public addToBag(dice:DiceData):void
        {
            this._bag[this._bag.length] = dice;
        }

        public getBag():Array<DiceData>
        {
            return this._bag;
        }


        public clearTheBag():void
        {
            this._bag = [];
        }

        public removeFromBag(dice: DiceData):void
        {

            for(var i:number = 0; i<5; i++)
            {
                if(this._bag[i] != null
                    && this._bag[i].id == dice.id
                    && this._bag[i].value == dice.value
                    && this._bag[i].color == dice.color
                )
                {
                    this._bag.splice(i,1);
                    break;
                }
            }

        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/User/UserScoreModel.ts